import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { StaffService } from 'src/app/model/staff.service';
import { UserDataService } from 'src/app/model/user-data.service';
import { SettingDataService } from 'src/app/model/setting-data.service';
import { DatePipe } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AlertService } from 'src/app/shared/Providers/RouterProvider/AlertProvider';
import { ToastrService } from 'ngx-toastr';
import { ChartModel, ChannelModel } from 'src/app/model/contract/channel';
import { StateModel } from 'src/app/model/contract/menu-program';
import { RegionDataService } from 'src/app/model/region-data.service';

@Component({
  selector: 'app-general-reports',
  templateUrl: './general-reports.component.html',
  styleUrls: ['./general-reports.component.scss']
})
export class GeneralReportsComponent implements OnInit {
  oneAtATime: boolean = true;
  userListModel: any;
  router: any;
  searchParams: any;
  totalCount: any;
  errorMessage: any;
  regionList: any;
  private _form: FormGroup;
  region: number;
  averagepointsearned: any;
  totalpointsissuedinlandd: any;
  topperforminglanddregionoutlet: any;
  avgredemptiontimebtuserandqc: any;
  RoleList: { id: number; name: string; }[];
  selectedChannel: number;
  state: number;
  selectedRole: number;
  tseusers: any;
  m2users: any;
  m3users: any;
  tse_user_id: number;
  m2_user_id: number;
  m3_user_id: number;
  avglanddopenrate: any;
  avgtimespentperlandd: any;

  constructor(private staffService: StaffService,
    private users: UserDataService,
    private _formBuilder: FormBuilder,
    public settingDataService: SettingDataService,
    public datepipe: DatePipe, 
    public formBuilder: FormBuilder,
    public ngxLoader: NgxUiLoaderService,
    public alertService: AlertService,
    private toastr: ToastrService,
    public usersService: RegionDataService) {

    this._form = this._formBuilder.group({
      date: ['',],
      region: ['',],
      state: ['',],
      channel: ['',],
      role: ['',],
      tse_user_id: ['',],
      m2_user_id: ['',],
      m3_user_id: ['',]
    });


  }

  ngOnInit() {

    this.getRegions();
    this.getStateList();
    this.getChannels();
    this.getUsers();
    this.region = 0;
    this.getEngagementReport(0, 0, 0, 0, 0, 0, 0, 0)
    this.region = 0;
    this.selectedChannel = 0;
    this.state = 0;
    this.selectedRole = 0;
    this.tse_user_id = 0;
    this.m2_user_id = 0;
    this.m3_user_id = 0;
  }

  getUsers(): void {
    this.users.getUsers()
      .subscribe(
        (result: any) => {
          this.tseusers = result.data.tseusers;
          this.m2users = result.data.m2users;
          this.m3users = result.data.m3users;
        },
        error => {
          this.alertService.error(error);
        }
      )
  }

  startDate: any = 0;
  endDate: any = 0;
  
  onSearch(date: any, region: any, state: any, channel: any, tse_user_id, m2_user_id, m3_user_id) {
    if (date != "") {
      this.startDate = this.datepipe.transform(date[0], 'yyyy-MM-dd');
      this.endDate = this.datepipe.transform(date[1], 'yyyy-MM-dd');
    }
    this.getEngagementReport(this.startDate, this.endDate, region, state, channel, tse_user_id, m2_user_id, m3_user_id);
  }

  getUserList(currentPage) {
    this.userListModel = null;
    this.users.getAllHubAdminUsers(1)
      .subscribe(
        (response: any) => {
          this.userListModel = response.data.users;
          this.totalCount = response.data.count.count;
        },
        error => {
          // unauthorized access
          if (error.status == 401 || error.status == 403) {
            this.staffService.unauthorizedAccess(error);
          } else {
            this.errorMessage = error.data.message;
          }
        }
      )
  }

  totalengagementvscompleted: any[];
  circleWiseData: Array<string> = [];
  public circleLabels: Array<string> = [];
  circleWiseData1: Array<string> = [];
  public circleLabels1: Array<string> = [];
  enagementPoints: number = 0;
  topperformingengagement: any[];
  topPerformingCSM: any[];
  public TSEDailybarChartLabels: any[] = [];
  public TSEDialybarChartData: any[] = [];
  public engagementCom: any;
  public enagementMonth: any[];
  public stateWise: any[];
  public RegionWise: any[];
  public TSEDailybarChartLabels2: any[] = [];
  public TSEDialybarChartData2: any[] = [];
  public TSEDailybarChartLabels3: any[] = [];
  public TSEDialybarChartData3: any[] = [];
  public TSEDailybarChartLabels4: any[] = [];
  public TSEDialybarChartData4: any[] = [];
  public TSEDailybarChartLabels5: any[] = [];
  public TSEDialybarChartData5: any[] = [];

  getEngagementReport(startdate, enddate, region, state, channel, tse_user_id, m2_user_id, m3_user_id) {
    this.setAllBlank();
    this.ngxLoader.start();
    this.users.getLearningReport(startdate, enddate, region, state, channel, tse_user_id, m2_user_id, m3_user_id)
      .subscribe(
        (result: any) => {
          this.totalengagementvscompleted = result.data.totallearningdeve.data;
          this.averagepointsearned = result.data.avgpointsissuedinlandd;
          this.engagementCom = result.data.totallearningdeve[0];
          this.totalpointsissuedinlandd = result.data.totalpointsissuedinlandd;
          console.log(this.engagementCom);
          if (this.totalengagementvscompleted.length !== 0) {
            this.circleLabels = ['Total L & D', 'Total Completed'];
            this.circleWiseData = result.data.totallearningdeve.data;
          }
          if (Object.getOwnPropertyNames(result.data.monthlytotallearningdeve).length !== 0) {
            let data = result.data.monthlytotallearningdeve;
            this.enagementMonth = data;
            this.TSEDailybarChartLabels = Object.values(result.data.monthlytotallearningdeve).map(e => e['month']);
            let chart: ChartModel = new ChartModel;
            let chart1: ChartModel = new ChartModel;
            data.forEach(element => {
              chart.data = Object.values(result.data.monthlytotallearningdeve).map(e => e['total_courses']);
              chart.label = 'Total Course';
            });

            data.forEach(element => {
              chart1.data = Object.values(result.data.monthlytotallearningdeve).map(e => e['course_completed']);
              chart1.label = 'Completed Course';
            });

            this.TSEDialybarChartData.push(chart);
            this.TSEDialybarChartData.push(chart1);
          }


          if (result.data.statewiseparticipantcount.length > 0) {
            if (Object.getOwnPropertyNames(result.data.statewiseparticipantcount).length !== 0) {
              let data = result.data.statewiseparticipantcount;
              this.stateWise = data;
              this.TSEDailybarChartLabels2 = Object.values(result.data.statewiseparticipantcount).map(e => e['state_name']);
              let chart: ChartModel = new ChartModel;
              let chart1: ChartModel = new ChartModel;
              data.forEach(element => {
                chart.data = Object.values(result.data.statewiseparticipantcount).map(e => e['total_count']);
                chart.label = 'Partcipation Count';
              });
              this.TSEDialybarChartData2.push(chart);
            }
          }

          if (result.data.retionwiseparticipantcount.length > 0) {
            if (Object.getOwnPropertyNames(result.data.retionwiseparticipantcount).length !== 0) {
              let data = result.data.retionwiseparticipantcount;
              this.RegionWise = data;
              this.TSEDailybarChartLabels3 = Object.values(result.data.retionwiseparticipantcount).map(e => e['region_name']);
              let chart: ChartModel = new ChartModel;
              let chart1: ChartModel = new ChartModel;
              data.forEach(element => {
                chart.data = Object.values(result.data.retionwiseparticipantcount).map(e => e['participant_count']);
                chart.label = 'Partcipation Count';
              });
              this.TSEDialybarChartData3.push(chart);
            }
          }

          if (result.data.avglanddopenrate.length > 0) {
            if (Object.getOwnPropertyNames(result.data.avglanddopenrate).length !== 0) {
              let data = result.data.avglanddopenrate;
              this.avglanddopenrate = data;
              this.TSEDailybarChartLabels4 = Object.values(result.data.avglanddopenrate).map(e => e['course_title']);
              let chart: ChartModel = new ChartModel;
              let chart1: ChartModel = new ChartModel;
              data.forEach(element => {
                chart.data = Object.values(result.data.avglanddopenrate).map(e => e['avg_open_rate']);
                chart.label = 'Average Count';
              });
              this.TSEDialybarChartData4.push(chart);
            }
          }

          if (result.data.avgtimespentperlandd.length > 0) {
            if (Object.getOwnPropertyNames(result.data.avgtimespentperlandd).length !== 0) {
              let data = result.data.avgtimespentperlandd;
              this.avgtimespentperlandd = data;
              this.TSEDailybarChartLabels5 = Object.values(result.data.avgtimespentperlandd).map(e => e['course_title']);
              let chart: ChartModel = new ChartModel;
              let chart1: ChartModel = new ChartModel;
              data.forEach(element => {
                chart.data = Object.values(result.data.avgtimespentperlandd).map(e => e['avg_spent_time_mins']);
                chart.label = 'Average Time Spend';
              });
              this.TSEDialybarChartData5.push(chart);
            }
          }

          // this.enagementPoints = result.data.totalpointsgiveninengagement;
          this.topPerformingCSM = result.data.topperforminglanddregion;
          this.topperformingengagement = result.data.topperforminglandd;
          this.topperforminglanddregionoutlet = result.data.topperforminglanddregionoutlet;
          this.ngxLoader.stop();
          //this.resetSchemesForm();
        },
        error => {
          // unauthorized access
          if (error.status == 401 || error.status == 403) {
          } else {
            this.alertService.error(error.data.message);
          }
        }
      )
  }



  setAllBlank() {
    this.circleLabels = [];
    this.circleWiseData = [];
    this.TSEDailybarChartLabels = [];
    this.TSEDialybarChartData = [];
    this.TSEDailybarChartLabels2 = [];
    this.TSEDialybarChartData2 = [];
    this.TSEDailybarChartLabels3 = [];
    this.TSEDialybarChartData3 = [];
    this.TSEDailybarChartLabels4 = [];
    this.TSEDialybarChartData4 = [];
    this.TSEDailybarChartLabels5 = [];
    this.TSEDialybarChartData5 = [];
  
  }

  resetSchemesForm() {
    this._form.reset();
    for (var name in this._form.controls) {
      this._form.controls[name].setErrors(null);
    }
  }


  public pieChartColors = [
    {
      backgroundColor: ['#003f5c', '#58508d'],
    },
  ];

  public pieChartColors1 = [
    {
      backgroundColor: ['#bc5090', '#ff6361'],
    },
  ];

  public barChartColors4: any[] = [
    {
      backgroundColor: '#e60000',
      pointBorderColor: '#fff'
    },
    {
      backgroundColor: '#ff6666',
      pointBorderColor: '#fff'
    },
  ]

  public barChartColors5: any[] = [
    {
      backgroundColor: '#663300',
      pointBorderColor: '#fff'
    },
    {
      backgroundColor: '#ff6666',
      pointBorderColor: '#fff'
    },
  ]

  public barChartColors6: any[] = [
    {
      backgroundColor: '#99b2b2',
      pointBorderColor: '#fff'
    },
    {
      backgroundColor: '#ff6666',
      pointBorderColor: '#fff'
    },
  ]

  getRegions(): void {
    this.settingDataService.getAllRegion()
      .subscribe(
        (result: any) => {
          this.regionList = result.data.regions;
        },
        error => {
          this.alertService.error(error);
        }
      )
  }


  onChangeRegion(item) {
    this.selectedStates = this.states.filter(s => s.region_id == item);
  }

  states: StateModel[];
  selectedStates: StateModel[];
  getStateList(): void {
    this.usersService.getAllStates().subscribe(
      (data) => {
        this.states = data;
      }
    )
  }

  onReset() {
    this.ngOnInit();
  }

  selectChannel() {

  }

  channelList: ChannelModel[];

  getChannels(): void {
    this.settingDataService.getAllChannel()
      .subscribe(
        (result: any) => {
          this.channelList = result.data.channels;
        },
        error => {
          this.alertService.error(error);
        }
      )
  }

}
